import React from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import UnsavedChangesPrompt from '@rd-web-markets/shared/dist/components/UnsavedChangesPrompt';
import { IntegerFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
const FIELDS_VERSION_7 = [{
  name: 'name',
  label: 'name',
  type: 'text'
}, {
  name: 'ocsce_is_civil_agreement',
  label: 'ocsce_is_civil_agreement',
  type: 'select'
}, {
  name: 'ocsce_total_remun_for_shareholders',
  label: 'ocsce_total_remun_for_shareholders',
  type: 'integer'
}, {
  name: 'ocsce_total_remun_for_project',
  label: 'ocsce_total_remun_for_project',
  type: 'integer'
}, {
  name: 'ocsce_total_working_hours_shareholder_on_project',
  label: 'ocsce_total_working_hours_shareholder_on_project',
  type: 'integer'
}, {
  name: 'ocsce_total_wh_shareholder_not_in_20_26',
  label: 'of_which_carried_out_not_in30jun2020till01jul2026',
  type: 'integer'
}, {
  name: 'ocsce_total_wh_shareholder_in_20_26',
  label: 'of_which_carried_out_in30jun2020till01jul2026',
  type: 'integer'
}];
const FIELDS_VERSION_8 = [{
  name: 'name',
  label: 'name',
  type: 'text'
}, {
  name: 'ocsce_is_civil_agreement',
  label: 'ocsce_is_civil_agreement',
  type: 'select'
}, {
  name: 'ocsce_total_remun_for_shareholders',
  label: 'ocsce_total_remun_for_shareholders',
  type: 'integer'
}, {
  name: 'ocsce_total_remun_for_project',
  label: 'ocsce_total_remun_for_project',
  type: 'integer'
}, {
  name: 'ocsce_total_working_hours_shareholder_on_project',
  label: 'ocsce_total_working_hours_shareholder_on_project',
  type: 'integer'
}, {
  name: 'ocsce_total_wh_shareholder_before_28_03_2024',
  label: 'of_which_carried_out_before28mar2024',
  type: 'integer'
}, {
  name: 'ocsce_total_wh_shareholder_after_27_03_2024',
  label: 'of_which_carried_out_after_27mar2024',
  type: 'integer'
}];
const ShareholderForm = _ref => {
  let {
    shareholder,
    closeForm,
    loading,
    change,
    submit,
    hasUnsavedChanges,
    isVersion8
  } = _ref;
  const {
    t
  } = useTranslation();
  const fields = isVersion8 ? FIELDS_VERSION_8 : FIELDS_VERSION_7;
  const renderField = field => {
    var _shareholder$field$na, _shareholder$field$na2, _shareholder$field$na3;
    switch (field.type) {
      case 'text':
        return /*#__PURE__*/React.createElement(Form.Control, {
          type: "text",
          name: field.name,
          value: (_shareholder$field$na = shareholder === null || shareholder === void 0 ? void 0 : shareholder[field.name]) !== null && _shareholder$field$na !== void 0 ? _shareholder$field$na : '',
          onChange: change,
          disabled: loading,
          "data-testid": "".concat(field.name, "-test-id")
        });
      case 'select':
        return /*#__PURE__*/React.createElement(Form.Control, {
          as: "select",
          name: field.name,
          value: (_shareholder$field$na2 = shareholder === null || shareholder === void 0 ? void 0 : shareholder[field.name]) !== null && _shareholder$field$na2 !== void 0 ? _shareholder$field$na2 : '',
          onChange: change,
          disabled: loading,
          "data-testid": "".concat(field.name, "-test-id")
        }, /*#__PURE__*/React.createElement("option", {
          value: ""
        }), /*#__PURE__*/React.createElement("option", {
          value: "true"
        }, t('yes')), /*#__PURE__*/React.createElement("option", {
          value: "false"
        }, t('no')));
      case 'integer':
        return /*#__PURE__*/React.createElement(IntegerFormFieldRow, {
          fieldName: field.name,
          value: (_shareholder$field$na3 = shareholder === null || shareholder === void 0 ? void 0 : shareholder[field.name]) !== null && _shareholder$field$na3 !== void 0 ? _shareholder$field$na3 : '',
          onChange: change,
          disabled: loading,
          dataTestId: "".concat(field.name, "-test-id"),
          style: {
            width: ''
          }
        });
      default:
        return null;
    }
  };
  const handleCloseForm = () => {
    if (hasUnsavedChanges) {
      var _window$MARKET_CONSTA;
      const message = t((_window$MARKET_CONSTA = window.MARKET_CONSTANTS) === null || _window$MARKET_CONSTA === void 0 ? void 0 : _window$MARKET_CONSTA.UNSAVED_CHANGES_MESSAGE);
      if (window.confirm(message)) {
        closeForm();
      }
    } else {
      closeForm();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, {
    className: "mx-4"
  }, fields.map(field => /*#__PURE__*/React.createElement(Row, {
    className: "mb-3",
    key: field.name
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t(field.label)), renderField(field)))))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "ms-2",
    onClick: submit,
    loading: loading,
    disabled: !hasUnsavedChanges,
    variant: "primary"
  }, t('save')), /*#__PURE__*/React.createElement(Button, {
    className: "ms-2",
    onClick: handleCloseForm,
    loading: loading,
    variant: "light"
  }, t('close_form'))))));
};
export default ShareholderForm;